(function () {

    'use strict';

    if (typeof window === 'undefined') {
        module.exports = exports(
            require('./metric.js'),
            require('./search.js'),
            require('../../enums/metrics.js'),
            require('../formatter.js'),
            require('lodash')
        );
    } else {
        RivalIQ.metric.format = exports(
            RivalIQ.metric,
            RivalIQ.metric.search,
            RivalIQ.enums,
            RivalIQ.formatter,
            window._
        );
    }

    function exports(metricFn, search, enums, formatter, _) {
        function isDeltaRelative(metric, data) {
            return metricFn.dimensionValue(metric, 'timeAnalysisMode', data) === enums.timeAnalysisMode.DELTA_RELATIVE;
        }

        /*
         * Returns an expanded format fn based on dimension, metric type, etc
         */
        function expandedFormatFn(metric, data, options) {
            // This is an interesting case - unlike other dimensions delta-relative
            // actually changes the output format from the metricType to
            // a percent
            if (isDeltaRelative(metric, data)) {
                return (val) => {
                    return formatter.absolutePercent(val, {
                        decimals: 2,
                        signFcn: formatter.changeSignPrefix
                    });
                };
            }

            const type = search.getPropertyValue(metric, 'type', data, options);

            if (type === enums.dataType.ABSOLUTE_PERCENT) {
                return formatter.absolutePercent;
            }

            if (type === enums.dataType.DURATION_SECONDS) {
                return formatter.formatSeconds;
            }

            if (type === enums.dataType.DURATION_MILLIS) {
                return formatter.formatTimeInterval;
            }

            if (type === enums.dataType.INTEGER) {
                return formatter.formats.integer;
            }

            if (type === enums.dataType.CURRENCY) {
                return formatter.formatAmountAndCurrency;
            }

            return formatter.formatExpandedNumeric;
        }

        /*
         * Returns a compact format fn based on dimension, metric type, etc
         */
        function compactFormatFn(metric, data, options) {
            if (isDeltaRelative(metric, data)) {
                return formatter.relativePercent;
            }

            const type = search.getPropertyValue(metric, 'type', data, options);
            if (type === enums.dataType.ABSOLUTE_PERCENT) {
                return formatter.absolutePercent;
            }

            if (type === enums.dataType.DURATION_SECONDS) {
                return formatter.formatSeconds;
            }

            if (type === enums.dataType.DURATION_MILLIS) {
                return formatter.formatTimeInterval;
            }

            return formatter.formats.abbreviated;
        }

        function formatFn(metric, data, options) {
            options = options || {};

            if (!options || !options.expand) {
                return compactFormatFn(metric, data, options);
            }
            return expandedFormatFn(metric, data, options);
        }

        // This function can be used for format a dimension value.
        // For example, given output like [['photo', 100], ['link', 200']], if
        // ui design requires printing 'photo', this fn returns the formatted
        // value via formatDimension(metric, 'type', 'photo')
        function formatDimension(metric, dimension, value, options) {
            const result = search.getDimensionValue(metric, ['csvFormat', 'format'], dimension, value);

            if (_.isFunction(result)) {
                return result(value, metric, options);
            }

            return result;
        }

        return {
            formatFn: formatFn,
            formatDimension: formatDimension,
            compactFormatFn: compactFormatFn,
            expandedFormatFn: expandedFormatFn
        };
    }
})();
